export default "__VITE_ASSET__DP$OeUAp__"